import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

type Parameter = {
    parentProductId: string;
    includeProductId: string;
    productName: string;
    qtyOrdered: number;
};

type HandlerType = Handler<Parameter>;

const DispatchChangeClipboardIncludeItem: HandlerType = props => {
    props.dispatch({
        type: "Widgets/Clipboard/SetIncludeItem",
        parameter: {
            parentProductId: props.parameter.parentProductId,
            includeProductId: props.parameter.includeProductId,
            productName: props.parameter.productName,
            qtyOrdered: props.parameter.qtyOrdered,
        },
    });
};

const chain = [DispatchChangeClipboardIncludeItem];

const changeClipboardIncludeItem = createHandlerChainRunner(chain, "ChangeClipboardIncludeItem");
export default changeClipboardIncludeItem;
